module.exports = __webpack_public_path__ + "img/s-photo.34ffc9c8.png";